import {USER_FIELD_ERROR, USER_SET_ITEM} from "./userActions";

export const commonConstants = {
    SIDEBAR_VISIBILITY_SET: 'SIDEBAR_VISIBILITY_SET',
    USERMENU_VISIBILITY_SET: 'USERMENU_VISIBILITY_SET',
    UPDATE_FIELD_AUTH: 'UPDATE_FIELD_AUTH',
    PAGEL_PRE_LOADED: 'PAGEL_PRE_LOADED',
    PAGE_REDIERCT: 'PAGE_REDIERCT',
    REDIRECTED: 'REDIRECTED',
    LOGOUT: 'LOGOUT',
    LOGIN: 'LOGIN',
    APP_LOAD: 'APP_LOAD',
    COMMON_IMAGE_UTL: 'COMMON_IMAGE_UTL',
};

export const FILTER = 'FILTER';

export const commonActions = {
    pagePreLoaded
}

export function pagePreLoaded(viewContainer) {
    let isLoginPage = ['LoginPage', 'RegisterPage'].indexOf(viewContainer) !== -1 ? false : true;
    return dispatch => {
        Promise.all([
            dispatch({type: commonConstants.SIDEBAR_VISIBILITY_SET, isSidebarVisible: isLoginPage}),
            dispatch({type: commonConstants.USERMENU_VISIBILITY_SET, isUsermenuVisible: isLoginPage})
        ]);
    };
}

export function filter(filter) {
    return { type: FILTER, data: filter }
}